import React from 'react';
import logo from '../assets/spario.png';
import './AuthLayout.css';

const AuthLayout = ({ children }) => {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src={logo} alt="Spario" />
        </div>
        {children}
        <div className="auth-footer">
          &copy; {new Date().getFullYear()} Spario. Wszelkie prawa zastrzeżone.
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
